<div class="vehicle-wrapper">
    <div class="top-header">
      <h3>Change Password</h3>
      <p>Please fill in all required fields</p>
    </div>
    <form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()">
      <div class="form-row">
        <div class="form-item">
          <label for="currentPassword">Current Password <small>*</small></label>
          <input type='password' formControlName="currentPassword" id="currentPassword">
          <div  class="error" *ngIf="changePasswordForm.get('currentPassword')?.invalid && changePasswordForm.get('currentPassword')?.touched">
            <small *ngIf="changePasswordForm.get('currentPassword')?.errors?.['required']">Current password is required.</small>
          </div>
        </div>
      <!-- </div> -->
      <!-- <div class="form-2"> -->
        <div class="form-item">
          <label for="newPassword">New Password (Min 3 &  Max 10 Characters) <small>*</small></label>
          <input type="password" formControlName="newPassword" id="newPassword" required />
          <div  class="error" *ngIf="changePasswordForm.get('newPassword')?.invalid && changePasswordForm.get('newPassword')?.touched">
            <small *ngIf="changePasswordForm.get('newPassword')?.errors?.['required']">New password is required</small>
          </div>
        </div>
        
      <!-- </div> -->
      <!-- <div class="form-2"> -->
        <div class="form-item">
          <label for="confirmNewpassword">Confirm New Password (Min 3 &  Max 10 Characters) <small>*</small></label>
          <div class="eye-visiblie">
            <input [type]="isPasswordVisible ? 'text' : 'password'" formControlName="confirmNewpassword" id="confirmNewpassword" required />
            <div (click)="togglePasswordVisibility()">
              <fa-icon *ngIf="isPassword" [icon]="passwordsMatch ? ['fas', 'check']:  ['fas', 'xmark']" [class]="passwordsMatch ? 'match-indicator': 'unmatch-indicator'"></fa-icon>
              <fa-icon [icon]="isPasswordVisible ? ['fas', 'eye'] : ['fas', 'eye-slash']" class="fa-thin"></fa-icon>
            </div>
            
          </div>
          <div  class="error" *ngIf="changePasswordForm.get('confirmNewpassword')?.invalid && changePasswordForm.get('confirmNewpassword')?.touched">
            <small *ngIf="changePasswordForm.get('confirmNewpassword')?.errors?.['required']">Confirm New Password is required</small>
          </div>
        </div>
      </div>
      <div class="button-row">
        <button type="submit"
        class="btn-save"
        [disabled]="loadingService.isLoading('change-password')"
        >
          <fa-icon [icon]="['fas', 'square-check']" class="fa-solid"></fa-icon>
          CHANGE
          <app-spinner 
            *ngIf="loadingService.isLoading('change-password')" 
            size="small"
          ></app-spinner>
        </button>
         <button type="button" class="btn-cancel" (click)="onCancel()">
            <fa-icon [icon]="['fas', 'square-xmark']" class="fa-thin"></fa-icon> CANCEL
          </button>
      </div>
    </form>
  </div>